const apiKey = "AIzaSyAsh-ofw4XiKuvo4W1GOIutG7NpHLbp2Hw";//process.env.REACT_APP_GOOGLE_API_KEY;

function useGoogleApi() {

    const getPlaceInformation = async (address) => {
        try {
            const encodedAddress = encodeURIComponent(address);
            const url = `https://maps.googleapis.com/maps/api/geocode/json?address=${encodedAddress}&key=${apiKey}`;

            const response = await fetch(url);
            const data = await response.json();

            const result = data.results[0];
            if (!result) return null;

            return {
                lat: result.geometry.location.lat,
                lng: result.geometry.location.lng,
                place_id: result.place_id,
                formatted_address: result.formatted_address,
            };
        } catch (error) {
            console.error("Error fetching place data:", error);
            return {};
        }
    }


    return {
        getPlaceInformation
    };
}

export default useGoogleApi;
